import React from "react";
import PageHero from "../components/PageHero";
import CTABanner from "../components/CTABanner";
import { PAST_PROJECTS } from "../data/site";
import { FileSearch, Mail } from "lucide-react";

export default function PastPerformance() {
  return (
    <div data-testid="page-past-performance">
      <PageHero
        eyebrow="Past Performance"
        title="Project experience and past performance summaries are available upon request."
        intro="Street Society maintains internal records of completed and ongoing scopes across its capability areas. Detailed past performance information is shared directly with contracting officers, primes, and qualified evaluators."
        image="blueprint"
      />

      <section className="section-y bg-white" data-testid="past-projects-grid">
        <div className="container-x">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-4">
              <p className="text-overline text-[#4B7055] mb-3">Project Categories</p>
              <h2 className="heading-section text-3xl sm:text-4xl text-[#0A1F35]">
                Capability areas with active experience.
              </h2>
              <p className="mt-5 text-[#4A5568] leading-relaxed">
                Each category below represents an area in which Street Society has executed scopes
                of work. Specific client references, dollar values, and performance documentation are
                available on request.
              </p>
              <a
                href="mailto:hello@streetsocietyllc.com?subject=Past%20Performance%20Request"
                className="btn-base btn-primary mt-7"
                data-testid="past-request-cta"
              >
                Request Past Performance <Mail size={16} />
              </a>
            </div>

            <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {PAST_PROJECTS.map((p, i) => (
                <article
                  key={p.title}
                  className="border border-[#E2E8F0] p-7 card-hover bg-white flex flex-col gap-4"
                  data-testid={`past-card-${i}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-overline text-[#9BB7A2]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <FileSearch size={18} className="text-[#9CA5B0]" strokeWidth={1.75} />
                  </div>
                  <h3 className="font-serif text-lg text-[#0A1F35] font-bold leading-snug">
                    {p.title}
                  </h3>
                  <p className="text-xs text-overline text-[#4B7055]">{p.sector}</p>
                  <p className="text-sm text-[#4A5568] leading-relaxed">{p.detail}</p>
                  <div className="mt-auto pt-4 border-t border-[#E2E8F0] text-xs text-[#4A5568]">
                    [Project details available on request]
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-[#0A1F35] text-white" data-testid="past-evaluators">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <p className="text-overline text-[#9BB7A2] mb-3">For Contracting Officers & Evaluators</p>
            <h2 className="heading-section text-3xl sm:text-4xl text-white">
              Need verified references or CPARS-style documentation?
            </h2>
            <p className="mt-5 text-white/80 leading-relaxed max-w-2xl">
              Street Society provides verified past performance documentation directly to authorized
              evaluators on request. Reach out via the contact channels below and we will respond
              promptly with appropriate materials.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <a
              href="mailto:hello@streetsocietyllc.com?subject=Past%20Performance%20Verification"
              className="btn-base bg-white text-[#0A1F35] hover:bg-[#C4A265]"
              data-testid="past-evaluator-cta"
            >
              Email Our Team <Mail size={16} />
            </a>
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
